<template>
  <v-list-item @click="toggleIntercom" class="intercom-button">
    <v-list-item-icon>
      <icon-base icon="sidebar/support" />
    </v-list-item-icon>
    <v-list-item-title class="pr-2">
      Talk to Support

      <v-fade-transition>
        <notifications-count-badge :count="unreadCount" />
      </v-fade-transition>
    </v-list-item-title>
  </v-list-item>
</template>

<script>
import EventBus from '@/factories/eventBus';
import NotificationsCountBadge from '@/components/layouts/sidebar/helpers/NotificationsCountBadge.vue';
import {
  show,
  hide,
  onUnreadCountChange,
  onHide,
  onShow,
} from '@intercom/messenger-js-sdk';

// SDK event listeners survive component remounts — register once per page load.
let listenersRegistered = false;

export default {
  name: 'IntercomButton',
  components: {
    NotificationsCountBadge,
  },
  data() {
    return {
      intercomVisible: false,
      unreadCount: 0,
    };
  },
  methods: {
    toggleIntercom() {
      if (this.intercomVisible) {
        hide();
        this.intercomVisible = false;
      } else {
        show();
        this.intercomVisible = true;
      }
    },
  },
  mounted() {
    if (listenersRegistered) return;
    listenersRegistered = true;

    onUnreadCountChange((unreadCount) => {
      if (this.unreadCount === unreadCount) return;
      this.unreadCount = unreadCount;
      this.$emit('unreadCountChange', unreadCount);
    });

    onHide(() => {
      this.intercomVisible = false;
    });

    onShow(() => {
      this.intercomVisible = true;
      EventBus.$emit('closeChatBot');
    });
  },
};
</script>

<style lang="less">
.intercom-button {
  position: relative;
}
</style>
